export default "__VITE_ASSET__CzHQBuBW__"